export default "__VITE_ASSET__B3l5TReC__"